class ImageWithTextSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".image-with-text-slider__swiper");
    this.pagination = this.querySelector(".image-with-text-slider__pagination");

    if (this.slider) {
      this.initSlider();
    }
  }

  initSlider() {
    if (typeof Swiper === "undefined") return;

    const perViewMobile = parseInt(this.dataset.mobileSlides) || 1;
    const perViewDesktop = parseInt(this.dataset.desktopSlides) || 1;
    const spacing = parseInt(this.dataset.spacing) || 0;

    new Swiper(this.slider, {
      slidesPerView: perViewMobile,
      spaceBetween: spacing,
      pagination: {
        el: this.pagination,
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: perViewDesktop,
        },
      },
    });
  }
}

customElements.define("image-with-text-slider", ImageWithTextSlider);
